import { useTranslation } from 'react-i18next';

interface IParams {
  isContactLocked: boolean;
  isVendorMapped: boolean;
}

// A `mapped` extractor with a saved contact: the mapping set the contact, like the vendor.
export const useMappedContactHelperTexts = ({
  isContactLocked,
  isVendorMapped,
}: IParams): string[] => {
  const { t } = useTranslation();

  return isVendorMapped && isContactLocked ? [t('messageVendorQuoteImportVendorMapped')] : [];
};
